import React, { useState, useEffect } from 'react';
import { MapPin, Clock, Loader2 } from 'lucide-react';
import { format } from 'date-fns';
import TextWithTooltip from '../../ui/TextWithTooltip';

export const PhotoMetadata = ({ timestamp, latitude, longitude, photoIndex, className = '', isShowTooltip = true }) => {
    const [locationName, setLocationName] = useState('');
    const [isLoadingLocation, setIsLoadingLocation] = useState(false);
    const [locationError, setLocationError] = useState(false);

    // Reverse geocoding function using OpenStreetMap Nominatim API
    const getLocationName = async (lat, lng) => {
        setIsLoadingLocation(true);
        setLocationError(false);

        try {
            const response = await fetch(
                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=14&addressdetails=1`
            );

            if (!response.ok) {
                throw new Error('Failed to fetch location');
            }

            const data = await response.json();

            if (data && data.address) {
                // Extract meaningful location parts
                const { neighbourhood, suburb, city, town, village, state, country } = data.address;

                // Build location string with available parts
                const locationParts = [neighbourhood || suburb, city || town || village, state, country].filter(
                    Boolean
                );

                setLocationName(locationParts.join(', '));
            } else {
                setLocationName(`${lat}, ${lng}`);
            }
        } catch (error) {
            console.error('Error fetching location:', error);
            setLocationError(true);
            setLocationName(`${lat}, ${lng}`);
        } finally {
            setIsLoadingLocation(false);
        }
    };

    // Format timestamp to readable format
    const formatTimestamp = (timestamp) => {
        console.log(timestamp, 'see what is time');
        try {
            const date = new Date(timestamp);
            console.log(date, 'date is here');
            // Format: "12:00 pm GMT +5:30, 22 Mar 2025"
            const timeString = format(date, 'h:mm a');
            const dateString = format(date, 'dd MMM yyyy');

            // Get timezone offset
            const timezoneOffset = date.getTimezoneOffset();
            const offsetHours = Math.floor(Math.abs(timezoneOffset) / 60);
            const offsetMinutes = Math.abs(timezoneOffset) % 60;
            const offsetSign = timezoneOffset <= 0 ? '+' : '-';
            const timezoneString = `GMT ${offsetSign}${offsetHours}:${offsetMinutes.toString().padStart(2, '0')}`;

            return `${timeString} ${timezoneString}, ${dateString}`;
        } catch (error) {
            console.error('Error formatting timestamp:', error);
            return 'Invalid date';
        }
    };

    // Fetch location when coordinates change
    useEffect(() => {
        if (latitude && longitude) {
            getLocationName(latitude, longitude);
        }
    }, [latitude, longitude]);

    if (!timestamp || !latitude || !longitude) {
        return null;
    }

    return (
        <div className={` mt-[.375rem] text-sm ${className}`}>
            <div className=" flex items-end text-[#137959]">
                <p className=" text-xs line-clamp-2">
                    Taken at {formatTimestamp(timestamp)}{' '}
                    {isLoadingLocation ? (
                        <div className="flex items-center space-x-1">
                            <Loader2 className="w-3 h-3 animate-spin" />
                            <span className="">Loading location...</span>
                        </div>
                    ) : locationError ? (
                        <span className="text-red-500">Location unavailable</span>
                    ) : (
                        <span className="">{locationName}</span>
                    )}{' '}
                </p>
                {isShowTooltip && (
                    <TextWithTooltip expandedTextWidth="w-96" expandedClassName="pt-3 pb-3" heading={''}>
                        <div>
                            <div className=" text-[#137959]">
                                <p className=" text-xs">
                                    Taken at {formatTimestamp(timestamp)}{' '}
                                    {isLoadingLocation ? (
                                        <div className="flex items-center space-x-1">
                                            <Loader2 className="w-3 h-3 animate-spin" />
                                            <span className="">Loading location...</span>
                                        </div>
                                    ) : locationError ? (
                                        <span className="text-red-500">Location unavailable</span>
                                    ) : (
                                        <span className="">{locationName}</span>
                                    )}{' '}
                                </p>
                            </div>
                            <p className="text-xs mt-[.375rem]">
                                This information was captured from the Impact Miner feature 'Field Notes', providing as
                                extra proof of work
                            </p>
                        </div>
                    </TextWithTooltip>
                )}
            </div>
        </div>
    );
};
